import { render } from "./ToolBarVistaFaenas.vue?vue&type=template&id=2d21047a"
import script from "./ToolBarVistaFaenas.vue?vue&type=script&lang=js"
export * from "./ToolBarVistaFaenas.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__